import { Request } from './../../infra/request'
import type { CreateFileDto } from './create-file.dto'
import { ConfigService } from '../../infra/config'
import { Store } from './../../infra/store.service'
import type { CacheService } from '../../infra/no-op-cache.service'

export class FilesService {
    private request: Request
    private store: Store
    constructor(
        private config: ConfigService = new ConfigService(),
        private token?: string,
        cache?: CacheService,
    ) {
        this.request = new Request(cache)
        this.store = new Store()
    }

    private get resolvedToken(): string {
        return this.token || this.store.token.token
    }

    async upload(dto: CreateFileDto): Promise<{ url: string }> {
        const data = {
            ...dto,
            folderName: 'front-upload',
        }
        const { json, statusCode, message } = await this.request.post(this.config.eventApiUrl + '/files/?token=' + this.resolvedToken, data)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async uploadToSignedLink(dto: CreateFileDto): Promise<{ url: string }> {
        try {
            // Converte o Base64 em um Blob para envio
            const base64Data = dto.content.split(',')[1] // Remove o prefixo "data:...;base64,"
            const binaryData = this.base64ToUint8Array(base64Data)
            const blob = new Blob([binaryData as any], { type: 'application/octet-stream' })

            // Realiza o envio do arquivo utilizando o link pré-assinado
            const presignedLink = await this.getPresignedLink(dto.extension, dto.folderName)
            console.log('presignedLink', presignedLink)

            if (!presignedLink?.signed) {
                throw 'Erro ao tentar enviar o arquivo. (Link pré-assinado não encontrado)'
            }

            const response = await fetch(presignedLink?.signed, {
                method: 'PUT',
                body: blob,
                headers: {
                    'Content-Type': 'application/octet-stream', // Define o tipo de arquivo enviado
                },
            })

            // Verifica se o envio foi bem-sucedido
            if (!response.ok) {
                throw `Erro ao enviar o arquivo: ${response.statusText}`
            }
            console.log('Arquivo enviado com sucesso!')
            return {
                url: presignedLink?.url,
            }
        } catch (error) {
            console.error('Erro ao enviar o arquivo:', error)
            throw error // Repropaga o erro para o chamador lidar
        }
    }

    private async getPresignedLink(extension: string, folderName: string) {
        const { json, statusCode, message } = await this.request.post(this.config.eventApiUrl + '/files?token=' + this.resolvedToken, {
            type: 'presigned',
            extension,
            folderName,
        })
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    // Função para converter Base64 em Uint8Array
    private base64ToUint8Array(base64: string): Uint8Array {
        const binaryString = window.atob(base64) // Decodifica o Base64
        const binaryLength = binaryString.length
        const bytes = new Uint8Array(binaryLength)

        for (let i = 0; i < binaryLength; i++) {
            bytes[i] = binaryString.charCodeAt(i)
        }

        return bytes
    }

    getExtension(fileName: string): string | null {
        const match = fileName.match(/\.([^\.]+)$/)
        return match ? match[1] : null
    }
}
